<template>
  <div
    ref="scrollButtonsWrapper"
    class="scroll-buttons-wrapper position-absolute d-flex justify-content-center align-items-end w-100 pr-2"
  >
    <VBtn
      v-if="selectedPoiId && !isScrollUpButtonShown && isScrollDownButtonShown"
      v-blur
      rounded
      small
      class="scroll-down-button mx-2 grey-lighten-4 box-shadow-elevation-12"
      data-test="scrollDownButton"
      @click="$emit('scrollToPoiSelection', selectedPoiType, { activePoi: true, id: selectedPoiId }, 'center')"
      >
      <VIcon
        class="pr-2"
        color="textSecondary"
      >
        mdi-arrow-down
      </VIcon>
      <span class="button textPrimary--text ">{{ $t('bookingForm.scrollToStops') }}</span>
    </VBtn>
    <VBtn
      v-else-if="selectedPoiId && directionContainerScrollPosition && isScrollUpButtonShown"
      v-blur
      small
      fab
      class="scroll-up-button mx-2"
      data-test="scrollUpButton"
      color="brandingPrimary box-shadow-elevation-6"
      @click="$emit('scrolToTop')"
      >
        <VIcon color="textWhite">
          mdi-arrow-up
        </VIcon>
      </VBtn>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ScrollButtons',
};
</script>

<script setup lang="ts">
import { ref, watch } from 'vue';

const props = defineProps({
  directionContainerScrollPosition: {
    type: Number,
    default: 0,
  },
  selectedPoiId: {
    type: String,
    default: null,
  },
  selectedPoiType: {
    type: String,
    default: null,
  },
});

const scrollButtonsWrapper = ref(null);
const isScrollUpButtonShown = ref(false);
const isScrollDownButtonShown = ref(false);
const timeOutId = ref(null);

watch(() => props.directionContainerScrollPosition, () => {
  setStyles();
  hideScrollDownButton();
}, { immediate: false });

watch(() => props.selectedPoiId, () => {
  clearTimeout(timeOutId.value);
  timeOutId.value = setTimeout(() => {
    setStyles();
    hideScrollDownButton();
  }, 300);
});

function setStyles() {
  const setLocationButton = document.getElementById('set-location-button');
  const container = document.getElementById('direction-dialog-container');

  if (setLocationButton) {
    isScrollUpButtonShown.value = !checkVisibility(setLocationButton, container);
    const stepperHeader = document.getElementsByClassName('stepper-container')[0];

    if (isScrollUpButtonShown.value) {
      scrollButtonsWrapper.value.style.bottom = null;
      scrollButtonsWrapper.value.style.top = `${stepperHeader.clientHeight + 20}px`;
    } else {
      const dialog = document.getElementsByClassName('direction-dialog')[0];
      scrollButtonsWrapper.value.style.top = `${dialog.clientHeight - 53}px`;
    }
  }
}

function hideScrollDownButton() {
  if (props.selectedPoiId) {
    const poiItemStop = document.getElementById(`poi-stop-${props.selectedPoiId}`);

    if (!poiItemStop) {
      isScrollDownButtonShown.value = false;
      return;
    }

    const container = document.getElementById('direction-dialog-container');
    const isVisiblePoiItem = checkVisibility(poiItemStop, container);

    if (isVisiblePoiItem && !isScrollUpButtonShown.value) {
      isScrollDownButtonShown.value = false;
    } else {
      isScrollDownButtonShown.value = true;
    }
  }
}

function checkVisibility(targetElement, container) {
  if (!targetElement) {
    return false;
  }

  const { bottom, height, top } = targetElement.getBoundingClientRect();
  const containerRect = container.getBoundingClientRect();

  return top <= containerRect.top ? containerRect.top - top <= height : bottom - containerRect.bottom <= height;
}
</script>

<style lang="scss">
.scroll-buttons-wrapper {
  .scroll-up-button {
    z-index: 3;
  }

  .scroll-down-button {
    z-index: 3;
    height: 36px !important;
   }
}
</style>
